/* istanbul ignore file */
import { AgTableServer } from "app/shared/AgTable";
import PageHeader from "app/shared/PageHeader";
import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { Select, Button, Modal, Input, message } from "antd"; // Import Ant Design components
import moment from "moment";

import { apiGet } from "app/services/apiServices";
import { API_ENDPOINT_FETCH_TEMPLATE_INFO } from "../HotelBookingView/hotel.booking.constants";
import { PlusOutlined, RightOutlined, LeftOutlined } from "@ant-design/icons";
import Handlebars from "handlebars";
import "./HotelEmailFollowUp.css";
import Typography from "app/shared/Typography";
import HotelDataUpdate from "./HotelDataUpdateEmai";
import { Skeleton, Statistic } from "antd";
import { API_ENDPOINT_EMAIL_FOLLOWUP_CLIENT_NAME } from "global.constants";
import { useNavigate } from "react-router-dom";
import { getSubdomain } from "app/utils/generic.helper";

import {
  AIRLINE_FOLLOWUP_COLUMN_DEFS,
  HOTEL_FOLLOWUP_COLUMN_DEFS,
  CLIENT_FOLLOWUP_COLUMN_DEFS,
} from "./email.follow.helpers";
import EmailActivityList from "../ActivityList";
import { Drawer } from "antd";
import { formatAmountIndian, convertFileToBase64 } from "./helpers";

const { Option } = Select;

const HotelEmail = () => {
  const { TextArea } = Input;
  const [selectedClient, setSelectedClient] = useState("");
  // const [isEditingPincode, setIsEditingPincode] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [contactDetails, setContactDetails] = useState(null);
  const [segmentType, setSegmentType] = useState("HOTEL");
  const [modalConfig, setModalConfig] = useState({ visible: false, type: "" });
  const [clientNames, setClientNames] = useState([]);
  // const [columnDefs, setColumnDefs] = useState([]);
  // const [templateDataBulk, setTemplateDataBulk] = useState(null);

  const [pendingUpdates, setPendingUpdates] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const agGridRef = useRef(null);
  const [eventData, setEventData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedEmailStatus, setSelectedEmailStatus] = useState("");
  const [selectedStatusLabel, setSelectedStatusLabel] = useState(null);
  const [isBulkMailModalVisible, setIsBulkMailModalVisible] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [showTextarea, setShowTextarea] = useState(false);
  const [customMessage, setCustomMessage] = useState("");
  // New state for single mail modal
  const [isResendModalVisible, setIsResendModalVisible] = useState(false);
  const [resendRowData, setResendRowData] = useState(null);

  // 1. Add state for CC and multi-checkbox sender selection
  const [ccEmails, setCcEmails] = useState([]);

  // Add state for single mail CC and sender multi-select
  const [ccEmailsSingle, setCcEmailsSingle] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0); // Add refresh trigger
  const [open, setOpen] = useState(false);
  const toggleDrawer = () => {
    setOpen((prev) => !prev);
  };

  const clientTemplateHtmlMapRef = useRef({});
  const [nocFile, setNocFile] = useState([]);

  // Handler to open single mail modal
  const openResendModal = (rowData) => {
    setResendRowData(rowData);
    setIsResendModalVisible(true);
  };
  // Handle Client Selection Change
  const handleChange = (value) => {
    setSelectedClient(value);
  };
  const controllerRef = useRef(null);

  const fetchEventSummary = async (clientId, segmentType) => {
    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    const controller = new AbortController();
    controllerRef.current = controller;
    setLoading(true); // ✅ start loading
    setEventData(null); // show skeleton

    try {
      const response = await fetch(
        `https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/event_summary`,
        //`http://192.168.0.193:7002/api/hotelFollowUp/event_summary`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            booking_client_id: clientId || "ALL",
            // segmentType: segmentType || "ALL"
            segmentType: segmentType
              ? segmentType.charAt(0).toUpperCase() +
                segmentType.slice(1).toLowerCase()
              : "ALL",
          }),
          signal: controller.signal,
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      setEventData(data);
    } catch (error) {
      void error;
    } finally {
      setLoading(false); // hide skeleton
    }
  };

  useEffect(() => {
    fetchEventSummary(selectedClient, segmentType);
  }, [selectedClient, segmentType]);

  const domain = getSubdomain();

  // removed unused openSidebarRenderer

  // removed unused showModal

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const openEmailModal = useCallback((data) => {
    setContactDetails(data);
    setModalConfig({ visible: true, type: "email" });
  }, []);

  const openPhoneModal = useCallback((data) => {
    setContactDetails(data);
    setModalConfig({ visible: true, type: "phone" });
  }, []);
  // removed unused handleEmailSubmit

  useEffect(() => {
    // fetchTemplateInfo();

    fetchClientNames();
  }, []);

  // const fetchTemplateInfo = async () => {
  //   const response = await apiGet(
  //     //   API_ENDPOINT_FETCH_TEMPLATE_INFO + "d-e2a6aa5cdc5240b9ac3f51e5782f9608"
  //     API_ENDPOINT_FETCH_TEMPLATE_INFO + "d-e2a6aa5cdc5240b9ac3f51e5782f9608"
  //   );
  //   console.log(response, "response sendgrid");
  //   if (response) {
  //     setTemplateData(response.html_content);
  //   }
  // };
  const fetchTemplateInfo = async (clientId, templateId) => {
    const response = await apiGet(
      API_ENDPOINT_FETCH_TEMPLATE_INFO + templateId,
    );

    // if (response?.html_content) {
    //   setClientTemplateHtmlMap((prevMap) => {
    //     const updatedMap = {
    //       ...prevMap,
    //       [clientId]: {
    //         html_content: response.html_content,
    //         client_id: clientId,
    //         template_id: templateId,
    //       },
    //     };
    //     return updatedMap;
    //   });
    // }
    if (response?.html_content) {
      clientTemplateHtmlMapRef.current[clientId] = {
        html_content: response.html_content,
        client_id: clientId,
        template_id: templateId,
      };
      // No setState here!
    }
  };

  // const renderTemplate = (htmlContent, data) => {
  //   console.log("htmlContent", htmlContent);
  //   const templateCompiler = Handlebars.compile(htmlContent);
  //   console.log(templateCompiler, "templateCompiler");
  //   const renderedContent = templateCompiler(data);
  //   console.log(renderedContent, "renderedContent");

  //   return renderedContent;
  // };

  const renderTemplate = (htmlContent, data) => {
    const templateCompiler = Handlebars.compile(htmlContent);
    const renderedContent = templateCompiler(data);
    return renderedContent;
  };

  // function openAllInvoices(links) {
  //   links.forEach((link) => {
  //     const url = link.trim();
  //     if (url) {
  //       window.open(url, "_blank");
  //     }
  //   });
  // }
  //--new fun

  const handleCellValueChange = useCallback((params) => {
    const { field } = params.colDef;
    const updatedValue = params.newValue;
    const rowData = params.data;

    const allowedFields = [
      "pincode",
      "email_hotel_name",
      "email_hotel_address",
      "email_hotel_gstin",
      "email_hotel_city",
      "remark1",
      "remark2",
    ];

    if (allowedFields.includes(field)) {
      // ✅ Check if this row is checkbox-selected
      const gridApi = agGridRef.current?.api;
      if (!gridApi) return;

      const selectedNodes = gridApi.getSelectedNodes();
      const isRowSelected = selectedNodes.some(
        (node) =>
          node.data &&
          (node.data.email_bookingId === rowData.email_bookingId ||
            node.data._id === rowData._id),
      );

      if (!isRowSelected) {
        return;
      }

      const rowId = rowData.email_bookingId || rowData._id;

      // ✅ Update editedRows Map to track multiple rows
      setEditedRows((prev) => {
        const newMap = new Map(prev);
        const existingRow = newMap.get(rowId) || { ...rowData };
        newMap.set(rowId, { ...existingRow, [field]: updatedValue });
        return newMap;
      });

      // ✅ Set edited pincode separately if relevant (removed)

      // ✅ Always show save button when any row is edited
      const saveBtn = document.getElementById("saveBtn");
      if (saveBtn) saveBtn.style.display = "block";
    }

    // ✅ Maintain pendingUpdates
    if (allowedFields.includes(field)) {
      setPendingUpdates((prev) => {
        const existing = prev.find(
          (item) => item.email_bookingId === rowData.email_bookingId,
        );

        if (existing) {
          return prev.map((item) =>
            item.email_bookingId === rowData.email_bookingId
              ? { ...item, [field]: updatedValue }
              : item,
          );
        } else {
          return [
            ...prev,
            { email_bookingId: rowData.email_bookingId, [field]: updatedValue },
          ];
        }
      });
    }
  }, []);

  const handleUpdateClick = async () => {
    try {
      for (let update of pendingUpdates) {
        const response = await fetch(
          "https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/cellDetailsUpdate",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(update),
          },
        );

        if (!response.ok) throw new Error("Failed to update");
      }

      setPendingUpdates([]);
    } catch (error) {
      void error;
    }
  };

  // Column Definitions for Ag-Grid

  const fetchClientNames = async () => {
    const response = await apiGet(API_ENDPOINT_EMAIL_FOLLOWUP_CLIENT_NAME);
    // const response = await apiGet("http://localhost:7001/api/hotelFollowUp/clientnames");
    if (response.status) {
      setClientNames(response.data);
      if (domain === "myyatra")
        setSelectedClient("YATRA_HOTEL_INVOICE_FOLLOWUP");
      response.data.forEach((client) => {
        if (client.templateId) {
          fetchTemplateInfo(client.client_id, client.templateId);
        }
      });
    }
  };

  const serverPayload = useMemo(
    () => ({
      database: "unified-hotel-followup",
      table: "booking-data",
      selectedClient,
      // type:segmentType,
      type: segmentType
        ? segmentType.charAt(0).toUpperCase() +
          segmentType.slice(1).toLowerCase()
        : segmentType,

      email_status: selectedEmailStatus,
      refreshTrigger: refreshTrigger, // Add refresh trigger to force data refresh
    }),
    [selectedClient, selectedEmailStatus, refreshTrigger],
  );

  const defaultColDef = {
    filter: true,
    floatingFilter: true,
    sortable: true,
    resizable: true,
    enableRowGroup: true,
    enablePivot: true,
    enableValue: true,

    cellStyle: { textAlign: "center" }, // Align cell values to the center
    headerClass: "header-center", // Apply custom class for headers
  };

  const navigate = useNavigate();

  const handleGridReady = (params) => {
    setGridApi(params.api);

    setTimeout(() => {
      params.api.forEachNode((node) => {
        if (node.group) node.setExpanded(true);
      });
    }, 500);
  };

  // Function to refresh grid data from server
  const refreshGridData = useCallback(() => {
    // Method 1: Try AgTableServer ref approach
    if (agGridRef && agGridRef.current) {
      const agTableComponent = agGridRef.current;

      // Access the internal grid API
      if (agTableComponent.api) {
        const api = agTableComponent.api;
        if (api.refreshServerSideStore) {
          api.refreshServerSideStore({ purge: true });
        } else if (api.refreshServerSide) {
          api.refreshServerSide();
        }
      }

      // Try to access AgTableServer's internal fetchServerSide method
      if (agTableComponent.fetchServerSide) {
        agTableComponent.fetchServerSide();
      }
    }

    // Method 2: Direct gridApi approach
    if (gridApi) {
      if (gridApi.refreshServerSideStore) {
        gridApi.refreshServerSideStore({ purge: true });
      } else if (gridApi.refreshServerSide) {
        gridApi.refreshServerSide();
      }
    }

    // Method 3: Force complete refresh with delay
    setTimeout(() => {
      if (gridApi && gridApi.refreshServerSideStore) {
        gridApi.refreshServerSideStore({ purge: true });
      }
    }, 100);

    // Method 4: Trigger refresh by updating state
    setRefreshTrigger((prev) => prev + 1);
  }, [gridApi, agGridRef]);

  // Effect to trigger refresh when refreshTrigger changes
  useEffect(() => {
    if (refreshTrigger > 0 && gridApi) {
      setTimeout(() => {
        if (gridApi.refreshServerSideStore) {
          gridApi.refreshServerSideStore({ purge: true });
        }
      }, 200);
    }
  }, [refreshTrigger, gridApi]);

  // Effect to handle cell update trigger
  // removed unused cellUpdateTrigger effect

  // Function to update row data - use minimal server-side refresh
  const updateRowData = useCallback(
    (_updatedRowData) => {
      // For AgTableServer with server-side data source, we need to refresh
      // But we can make it as minimal as possible

      if (gridApi) {
        // Use the most efficient refresh method
        if (gridApi.refreshServerSideStore) {
          gridApi.refreshServerSideStore({ purge: true });
        } else if (gridApi.refreshServerSide) {
          gridApi.refreshServerSide();
        }
      }

      // Also try using the AgTableServer ref
      if (agGridRef && agGridRef.current) {
        const agTableComponent = agGridRef.current;

        if (agTableComponent.api) {
          const api = agTableComponent.api;
          if (api.refreshServerSideStore) {
            api.refreshServerSideStore({ purge: true });
          } else if (api.refreshServerSide) {
            api.refreshServerSide();
          }
        }
      }
    },
    [gridApi, agGridRef],
  );

  // const handleFirstDataRendered = (params) => {
  //   params.columnApi.setRowGroupColumns([
  //     "followup_completed", "company_name", "airline_name"
  //   ]);
  // };
  const handleFirstDataRendered = (params) => {
    if (segmentType === "AIRLINE") {
      params.columnApi.setRowGroupColumns([
        "followup_completed",
        "company_name",
        "airline_name",
      ]);
    }
  };

  // const columnDefs = useMemo(() => {
  //   return segmentType === "HOTEL"
  //     ? HOTEL_FOLLOWUP_COLUMN_DEFS({
  //         setModalType,
  //         setModalData,
  //         setIsModalVisible,
  //       })
  //     : AIRLINE_FOLLOWUP_COLUMN_DEFS({
  //         setModalType,
  //         setModalData,
  //         setIsModalVisible,
  //       });
  // }, [segmentType, setModalType, setModalData, setIsModalVisible]);

  // Helper to check if any rows are selected (unused)

  // formatAmountIndian moved to module scope

  const StatusCard = ({
    label,
    value,
    icon,
    type,
    onClick,
    isSelected,
    customStyle,
    gst,
  }) => {
    const isFailure = type === "failure";
    let borderStyle = "none";
    if (isSelected) {
      borderStyle = isFailure ? "2px solid #E53935" : "2px solid #0A8394";
    }

    // Special rendering for Invoice Received/Not Received
    if (
      ["Invoice Received", "Invoice Not Received", "Email Required"].includes(
        label,
      )
    ) {
      return (
        <div
          onClick={onClick}
          style={{
            cursor: "pointer",
            border: borderStyle,
            borderRadius: 8,
            boxSizing: "border-box",
            ...customStyle,
            width: 180,
            minWidth: 204,
            // maxWidth: 180,
            height: 113,
            // minHeight: 120,
            // maxHeight: 120,
            // background: "#f8fcfd",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 8px",
          }}
          className={isFailure ? "bouncedContainer" : "deliveredContainer"}
        >
          <Typography
            className={isFailure ? "bouncedTxt" : "deliveredTxt"}
            style={{ fontSize: 16, color: "#666", fontWeight: 500 }}
          >
            {label}
          </Typography>
          <div
            style={{
              fontSize: 18,
              fontWeight: 700,
              color: isFailure ? "#E53935" : "#0A8394",
              marginTop: 4,
              display: "flex",
              alignItems: "center",
            }}
          >
            <span style={{ fontSize: 14, marginRight: 2 }}>₹</span>
            {formatAmountIndian(gst)}
          </div>
          <div style={{ fontSize: 13, color: "#888", marginTop: 2 }}>
            Count:{" "}
            <span
              style={{
                color: isFailure ? "#E53935" : "#0A8394",
                fontWeight: 600,
              }}
            >
              {value?.toLocaleString?.() ?? value}
            </span>
          </div>
        </div>
      );
    }

    return (
      <div
        onClick={onClick}
        style={{
          cursor: "pointer",
          border: borderStyle,
          borderRadius: 8,
          boxSizing: "border-box",
          ...customStyle,
        }}
        className={isFailure ? "bouncedContainer" : "deliveredContainer"}
      >
        <div className={isFailure ? "iconBounced" : "iconDelivered"}>
          <span>{icon}</span>
          <Typography className={isFailure ? "bouncedTxt" : "deliveredTxt"}>
            {label}
          </Typography>
        </div>
        <div
          className={isFailure ? "bouncedCount" : "deliveredCount"}
          style={{ maxWidth: 80 }}
        >
          {gst !== undefined && gst !== null && (
            <div
              style={{
                fontSize: "25px",
                fontWeight: 700,
                color: isFailure ? "#E53935" : "#0A8394",
                marginTop: 4,
                whiteSpace: "nowrap",
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <span
                style={{
                  fontSize: "15px",
                  fontWeight: 700,
                  marginRight: 2,
                  display: "inline-block",
                }}
              >
                ₹
              </span>
              {formatAmountIndian(gst)}
            </div>
          )}
          {["Invoice Received", "Invoice Not Received"].includes(label) ? (
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <span
                style={{ fontSize: "12px", color: "#666", fontWeight: 500 }}
              >
                Count:
              </span>
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: 500,
                  lineHeight: "24px",
                  color: isFailure ? "#E53935" : "#0A8394",
                }}
              >
                {value?.toLocaleString?.() ?? value}
              </span>
            </div>
          ) : (
            <Statistic
              value={value}
              valueStyle={{
                fontSize: "18px", // reduced font size
                fontWeight: 500,
                lineHeight: "24px",
                color: isFailure ? "#E53935" : "#0A8394",
              }}
            />
          )}
        </div>
      </div>
    );
  };

  const summaryCards = [
    {
      label: "Delivered",
      value: eventData?.summary?.delivered,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            d="M6 3C5.5 3 5.1 3.2 4.8 3.6L3.5 5.2C3.2 5.6 3 6 3 6.5V19C3 20.1 3.9 21 5 21H13.3C13.1 20.4 13 19.7 13 19C13 15.7 15.7 13 19 13C19.7 13 20.4 13.1 21 13.3V6.5C21 6 20.8 5.6 20.5 5.2L19.1 3.5C18.9 3.2 18.5 3 18 3H6ZM5.9 4H17.9L18.8 5H5.1L5.9 4ZM6 15H12V18H6V15ZM21.3 15.8L17.7 19.4L16.1 17.8L15 19L17.8 22L22.6 17.2L21.3 15.8Z"
            fill="#0A8394"
          />
        </svg>
      ),
      type: "success",
    },
    {
      label: "Open",
      value: eventData?.summary?.open,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            d="M14.872 14.2872L21.394 20.8072C21.1324 21.154 20.7985 21.4399 20.4156 21.645C20.0326 21.8501 19.6097 21.9696 19.176 21.9952L19 22.0002H5C4.53604 22.0003 4.07837 21.8928 3.66297 21.6862C3.24757 21.4795 2.88577 21.1793 2.606 20.8092L9.127 14.2872L11.445 15.8322L11.561 15.8982C11.6977 15.965 11.8478 15.9997 12 15.9997C12.1522 15.9997 12.3023 15.965 12.439 15.8982L12.555 15.8322L14.872 14.2872Z"
            fill="#0A8394"
          />
          <path
            d="M2 9.53521L7.429 13.1552L2 18.5852V9.53521Z"
            fill="#0A8394"
          />
          <path
            d="M22 9.53521V18.5852L16.57 13.1552L22 9.53521Z"
            fill="#0A8394"
          />
          <path
            d="M12.44 2.10221L12.555 2.16821L20.999 7.79721L12 13.7972L3 7.79721L11.445 2.16721C11.5906 2.07045 11.7589 2.01354 11.9333 2.00213C12.1077 1.99073 12.2831 2.02523 12.44 2.10221Z"
            fill="#0A8394"
          />
        </svg>
      ),
      type: "success",
    },
    {
      label: "Click",
      value: eventData?.summary?.click,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M9.5 1.99979C10.1347 1.99969 10.7457 2.24102 11.209 2.67483C11.6724 3.10863 11.9534 3.70244 11.995 4.33579L12 4.49979V9.10479L17.442 9.70979C18.3855 9.81464 19.261 10.2516 19.9119 10.9427C20.5628 11.6337 20.9467 12.5337 20.995 13.4818L21 13.6848V13.9998C21 16.0782 20.1911 18.075 18.7445 19.5675C17.298 21.0599 15.3274 21.9308 13.25 21.9958L13 21.9998H12.326C10.8885 21.9998 9.47751 21.6124 8.24148 20.8784C7.00546 20.1444 5.99004 19.091 5.302 17.8288L5.171 17.5778L2.329 11.8938C1.969 11.1738 2.236 10.2108 3.076 9.86579C4.119 9.43879 5.11 9.35879 6.131 9.87779C6.353 9.99112 6.571 10.1291 6.785 10.2918L7 10.4618V4.49979C7 3.83675 7.26339 3.20086 7.73223 2.73202C8.20107 2.26318 8.83696 1.99979 9.5 1.99979ZM4 5.99979C4.26522 5.99979 4.51957 6.10514 4.70711 6.29268C4.89464 6.48022 5 6.73457 5 6.99979C5 7.265 4.89464 7.51936 4.70711 7.70689C4.51957 7.89443 4.26522 7.99979 4 7.99979H3C2.73478 7.99979 2.48043 7.89443 2.29289 7.70689C2.10536 7.51936 2 7.265 2 6.99979C2 6.73457 2.10536 6.48022 2.29289 6.29268C2.48043 6.10514 2.73478 5.99979 3 5.99979H4ZM16 4.99979C16.2549 5.00007 16.5 5.09767 16.6854 5.27263C16.8707 5.4476 16.9822 5.68674 16.9972 5.94118C17.0121 6.19562 16.9293 6.44617 16.7657 6.64162C16.6021 6.83707 16.3701 6.96268 16.117 6.99279L16 6.99979H15C14.7451 6.9995 14.5 6.90191 14.3146 6.72694C14.1293 6.55197 14.0178 6.31283 14.0028 6.05839C13.9879 5.80395 14.0707 5.55341 14.2343 5.35795C14.3979 5.1625 14.6299 5.03689 14.883 5.00679L15 4.99979H16ZM4.707 1.29279L5.707 2.29279C5.88916 2.48139 5.98995 2.73399 5.98767 2.99619C5.9854 3.25838 5.88023 3.5092 5.69482 3.6946C5.50941 3.88001 5.2586 3.98518 4.9964 3.98746C4.7342 3.98974 4.4816 3.88894 4.293 3.70679L3.293 2.70679C3.11084 2.51818 3.01005 2.26558 3.01233 2.00339C3.0146 1.74119 3.11977 1.49038 3.30518 1.30497C3.49059 1.11956 3.7414 1.01439 4.0036 1.01211C4.2658 1.00983 4.5184 1.11063 4.707 1.29279ZM15.707 1.29279C15.8945 1.48031 15.9998 1.73462 15.9998 1.99979C15.9998 2.26495 15.8945 2.51926 15.707 2.70679L14.707 3.70679C14.6148 3.8023 14.5044 3.87848 14.3824 3.93089C14.2604 3.9833 14.1292 4.01088 13.9964 4.01204C13.8636 4.01319 13.7319 3.98789 13.609 3.93761C13.4861 3.88733 13.3745 3.81307 13.2806 3.71918C13.1867 3.62529 13.1125 3.51364 13.0622 3.39074C13.0119 3.26784 12.9866 3.13616 12.9877 3.00339C12.9889 2.87061 13.0165 2.73939 13.0689 2.61738C13.1213 2.49538 13.1975 2.38503 13.293 2.29279L14.293 1.29279C14.4805 1.10532 14.7348 1 15 1C15.2652 1 15.5195 1.10532 15.707 1.29279Z"
            fill="#0A8394"
          />
        </svg>
      ),
      type: "success",
    },
    {
      label: "Bounce",
      value: eventData?.summary?.bounce,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M14.143 11.486C14.2842 11.2691 14.504 11.1154 14.7562 11.0572C15.0085 10.999 15.2734 11.0409 15.4954 11.174C15.7174 11.3071 15.8791 11.5211 15.9465 11.771C16.014 12.021 15.9819 12.2873 15.857 12.514C14.355 15.019 13.447 17.404 12.987 20.164C12.827 21.12 11.539 21.314 11.106 20.447C9.04598 16.327 7.24798 15.471 4.31599 16.449C4.19136 16.4905 4.05978 16.507 3.92876 16.4977C3.79775 16.4883 3.66985 16.4533 3.55239 16.3945C3.31515 16.2758 3.13479 16.0677 3.05099 15.816C2.96718 15.5643 2.98678 15.2896 3.1055 15.0524C3.22421 14.8152 3.43229 14.6348 3.68399 14.551C6.88399 13.484 9.33998 14.178 11.487 17.174L11.578 17.304L11.589 17.264C12.111 15.436 12.856 13.714 13.862 11.964L14.143 11.486ZM18 4C17.606 4 17.2159 4.0776 16.8519 4.22836C16.488 4.37913 16.1572 4.6001 15.8787 4.87868C15.6001 5.15726 15.3791 5.48797 15.2283 5.85195C15.0776 6.21593 15 6.60603 15 7C15 7.39397 15.0776 7.78407 15.2283 8.14805C15.3791 8.51203 15.6001 8.84274 15.8787 9.12132C16.1572 9.3999 16.488 9.62087 16.8519 9.77164C17.2159 9.9224 17.606 10 18 10C18.7956 10 19.5587 9.68393 20.1213 9.12132C20.6839 8.55871 21 7.79565 21 7C21 6.20435 20.6839 5.44129 20.1213 4.87868C19.5587 4.31607 18.7956 4 18 4Z"
            fill="#E53935"
          />
        </svg>
      ),
      type: "failure",
    },
    {
      label: "Dropped",
      value: eventData?.summary?.dropped,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path d="M9 4H15V12H19.84L12 19.84L4.16 12H9V4Z" fill="#E53935" />
        </svg>
      ),
      type: "failure",
    },
    {
      label: "Deferred",
      value: eventData?.summary?.deferred,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M17.5 12C18.9587 12 20.3576 12.5795 21.3891 13.6109C22.4205 14.6424 23 16.0413 23 17.5C23 18.9587 22.4205 20.3576 21.3891 21.3891C20.3576 22.4205 18.9587 23 17.5 23C16.0413 23 14.6424 22.4205 13.6109 21.3891C12.5795 20.3576 12 18.9587 12 17.5C12 16.0413 12.5795 14.6424 13.6109 13.6109C14.6424 12.5795 16.0413 12 17.5 12ZM15.024 15.024C14.9303 15.1178 14.8776 15.2449 14.8776 15.3775C14.8776 15.5101 14.9303 15.6372 15.024 15.731L16.793 17.501L15.026 19.267C14.9795 19.3134 14.9426 19.3685 14.9174 19.4292C14.8923 19.4899 14.8793 19.5549 14.8792 19.6206C14.8792 19.6863 14.8921 19.7514 14.9172 19.8121C14.9423 19.8728 14.9791 19.928 15.0255 19.9745C15.0719 20.021 15.127 20.0579 15.1877 20.0831C15.2484 20.1082 15.3134 20.1212 15.3791 20.1213C15.4448 20.1213 15.5099 20.1084 15.5706 20.0833C15.6313 20.0582 15.6865 20.0214 15.733 19.975L17.5 18.208L19.27 19.977C19.3161 20.0248 19.3713 20.0628 19.4323 20.0891C19.4933 20.1153 19.5589 20.129 19.6253 20.1296C19.6917 20.1302 19.7575 20.1176 19.819 20.0924C19.8804 20.0673 19.9363 20.0301 19.9832 19.9832C20.0301 19.9363 20.0673 19.8804 20.0924 19.819C20.1176 19.7575 20.1302 19.6917 20.1296 19.6253C20.129 19.5589 20.1153 19.4933 20.0891 19.4323C20.0628 19.3713 20.0248 19.3161 19.977 19.27L18.208 17.5L19.979 15.73C20.0701 15.6357 20.1205 15.5094 20.1193 15.3783C20.1182 15.2472 20.0656 15.1218 19.9729 15.0291C19.8802 14.9364 19.7548 14.8838 19.6237 14.8827C19.4926 14.8815 19.3663 14.9319 19.272 15.023L17.501 16.793L15.731 15.023C15.6372 14.9293 15.5101 14.8766 15.3775 14.8766C15.2449 14.8766 15.1178 14.9293 15.024 15.023M21 8.5L21.001 12.023C19.7529 11.2239 18.2692 10.8752 16.7958 11.0349C15.3224 11.1946 13.9478 11.8529 12.8999 12.9009C11.8519 13.9488 11.1936 15.3234 11.0339 16.7968C10.8742 18.2702 11.2229 19.7539 12.022 21.002L6.25 21C5.38805 21 4.5614 20.6576 3.9519 20.0481C3.34241 19.4386 3 18.612 3 17.75V8.5H21ZM17.75 3C18.612 3 19.4386 3.34241 20.0481 3.9519C20.6576 4.5614 21 5.38805 21 6.25V7H3V6.25C3 5.38805 3.34241 4.5614 3.9519 3.9519C4.5614 3.34241 5.38805 3 6.25 3H17.75Z"
            fill="#E53935"
          />
        </svg>
      ),
      type: "failure",
    },
    {
      label: "Email Required",
      //value: eventData?.summary?.EMAILREQUIRED?.totalGST,
      gst: eventData?.summary?.EMAILREQUIRED?.totalGST,
      value: eventData?.summary?.EMAILREQUIRED?.uniqueCount,
      type: "failure",
    },
    {
      label: "Invoice Received",
      gst: eventData?.summary?.["Invoice Received"]?.totalGST,
      value: eventData?.summary?.["Invoice Received"]?.count,

      // icon: (
      //   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      //     <path d="M6 3C5.5 3 5.1 3.2 4.8 3.6L3.5 5.2C3.2 5.6 3 6 3 6.5V19C3 20.1 3.9 21 5 21H13.3C13.1 20.4 13 19.7 13 19C13 15.7 15.7 13 19 13C19.7 13 20.4 13.1 21 13.3V6.5C21 6 20.8 5.6 20.5 5.2L19.1 3.5C18.9 3.2 18.5 3 18 3H6ZM5.9 4H17.9L18.8 5H5.1L5.9 4ZM6 15H12V18H6V15ZM21.3 15.8L17.7 19.4L16.1 17.8L15 19L17.8 22L22.6 17.2L21.3 15.8Z" fill="#0A8394" />
      //   </svg>
      // ),
      type: "success",
      //customStyle: { minWidth: 120, maxWidth: 140 }
    },
    {
      label: "Invoice Not Received",
      gst: eventData?.summary?.["Invoice Not Received"]?.totalGST,
      value: eventData?.summary?.["Invoice Not Received"]?.count,

      // icon: (
      //   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      //     <path d="M17.5 12C18.9587 12 20.3576 12.5795 21.3891 13.6109C22.4205 14.6424 23 16.0413 23 17.5C23 18.9587 22.4205 20.3576 21.3891 21.3891C20.3576 22.4205 18.9587 23 17.5 23C16.0413 23 14.6424 22.4205 13.6109 21.3891C12.5795 20.3576 12 18.9587 12 17.5C12 16.0413 12.5795 14.6424 13.6109 13.6109C14.6424 12.5795 16.0413 12 17.5 12ZM15.024 15.024C14.9303 15.1178 14.8776 15.2449 14.8776 15.3775C14.8776 15.5101 14.9303 15.6372 15.024 15.731L16.793 17.501L15.026 19.267C14.9795 19.3134 14.9426 19.3685 14.9174 19.4292C14.8923 19.4899 14.8793 19.5549 14.8792 19.6206C14.8792 19.6863 14.8921 19.7514 14.9172 19.8121C14.9423 19.8728 14.9791 19.928 15.0255 19.9745C15.0719 20.021 15.127 20.0579 15.1877 20.0831C15.2484 20.1082 15.3134 20.1212 15.3791 20.1213C15.4448 20.1213 15.5099 20.1084 15.5706 20.0833C15.6313 20.0582 15.6865 20.0214 15.733 19.975L17.5 18.208L19.27 19.977C19.3161 20.0248 19.3713 20.0628 19.4323 20.0891C19.4933 20.1153 19.5589 20.129 19.6253 20.1296C19.6917 20.1302 19.7575 20.1176 19.819 20.0924C19.8804 20.0673 19.9363 20.0301 19.9832 19.9832C20.0301 19.9363 20.0673 19.8804 20.0924 19.819C20.1176 19.7575 20.1302 19.6917 20.1296 19.6253C20.129 19.5589 20.1153 19.4933 20.0891 19.4323C20.0628 19.3713 20.0248 19.3161 19.977 19.27L18.208 17.5L19.979 15.73C20.0701 15.6357 20.1205 15.5094 20.1193 15.3783C20.1182 15.2472 20.0656 15.1218 19.9729 15.0291C19.8802 14.9364 19.7548 14.8838 19.6237 14.8827C19.4926 14.8815 19.3663 14.9319 19.272 15.023L17.501 16.793L15.731 15.023C15.6372 14.9293 15.5101 14.8766 15.3775 14.8766C15.2449 14.8766 15.1178 14.9293 15.024 15.023M21 8.5L21.001 12.023C19.7529 11.2239 18.2692 10.8752 16.7958 11.0349C15.3224 11.1946 13.9478 11.8529 12.8999 12.9009C11.8519 13.9488 11.1936 15.3234 11.0339 16.7968C10.8742 18.2702 11.2229 19.7539 12.022 21.002L6.25 21C5.38805 21 4.5614 20.6576 3.9519 20.0481C3.34241 19.4386 3 18.612 3 17.75V8.5H21ZM17.75 3C18.612 3 19.4386 3.34241 20.0481 3.9519C20.6576 4.5614 21 5.38805 21 6.25V7H3V6.25C3 5.38805 3.34241 4.5614 3.9519 3.9519C4.5614 3.34241 5.38805 3 6.25 3H17.75Z" fill="#E53935" />
      //   </svg>
      // ),
      type: "failure",
    },
  ];

  const handleEmailFilter = (status) => {
    const normalizedStatus = status === "All" ? "" : status.toLowerCase();
    setSelectedEmailStatus(normalizedStatus);
  };

  // removed unused gridRef

  const handleBookingIdFilter = (bookingId) => {
    if (agGridRef.current) {
      if (!bookingId) {
        agGridRef.current.setFilterModel({});
        return;
      }

      agGridRef.current.setFilterModel({
        email_bookingId: {
          type: "contains",
          filter: bookingId,
        },
      });
    }
  };

  // const handleBookingIdFilterBulk = (bookingId) => {
  //   if (agGridRef.current) {
  //     if (!bookingId?.trim()) {
  //       agGridRef.current.setFilterModel({});
  //       return;
  //     }

  //     agGridRef.current.setFilterModel({
  //       email_bookingId: {
  //         type: "custom",
  //         filter: bookingId, // e.g. "9041,9042,9043"
  //       },
  //     });

  //     agGridRef.current.onFilterChanged();
  //   }
  // };

  const handleBookingIdFilterBulk = (bookingIdString) => {
    if (agGridRef.current) {
      if (!bookingIdString?.trim()) {
        agGridRef.current.setFilterModel({});
        return;
      }

      // Clean up the string to avoid extra spaces
      const cleanedBookingIdString = bookingIdString
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id.length > 0)
        .join(",");

      agGridRef.current.setFilterModel({
        email_bookingId: {
          type: "custom", // Inform server-side filtering logic
          filter: cleanedBookingIdString, // e.g. "9041,9042,9043"
        },
      });

      agGridRef.current.onFilterChanged();
    }
  };
  // removed unused findColumnDefByField
  // const columnDefs = useMemo(() => {
  //   return segmentType === "HOTEL"
  //     ? HOTEL_FOLLOWUP_COLUMN_DEFS({
  //       setModalType,
  //       setModalData,
  //       setIsModalVisible,
  //       openPhoneModal,
  //       openEmailModal,
  //       openResendModal,
  //     })
  //     : AIRLINE_FOLLOWUP_COLUMN_DEFS({
  //       setModalType,
  //       setModalData,
  //       setIsModalVisible,
  //       openPhoneModal,
  //       openEmailModal,
  //       openResendModal,
  //     });
  // }, [segmentType, setModalType, setModalData, setIsModalVisible]);

  const setModalType = () => {};
  const columnDefs = useMemo(() => {
    return segmentType === "HOTEL"
      ? HOTEL_FOLLOWUP_COLUMN_DEFS({
          setModalType,
          setModalData,
          setIsModalVisible,
          openPhoneModal,
          openEmailModal,
          openResendModal,
        })
      : segmentType === "CLIENT"
        ? CLIENT_FOLLOWUP_COLUMN_DEFS({
            setModalType,
            setModalData,
            setIsModalVisible,
            openPhoneModal,
            openEmailModal,
            openResendModal,
          })
        : AIRLINE_FOLLOWUP_COLUMN_DEFS({
            setModalType,
            setModalData,
            setIsModalVisible,
            openPhoneModal,
            openEmailModal,
            openResendModal,
          });
  }, [segmentType, setModalType, setModalData, setIsModalVisible]);

  const emailOptions = [
    {
      label: "Monica (monica@kgrp.in)",
      value: "monica@kgrp.in",
      name: "Monica",
    },
    { label: "Aman (aman07@kgrp.in)", value: "aman07@kgrp.in", name: "Aman" },
    {
      label: "Pavithra (pavithra@kgrp.in)",
      value: "pavithra@kgrp.in",
      name: "Pavithra",
    },
    {
      label: "Rakesh (rakesh@kgrp.in)",
      value: "rakesh@kgrp.in",
      name: "Rakesh",
    },
    {
      label: "Chaitra (chaitra@kgrp.in)",
      value: "chaitra@kgrp.in",
      name: "Chaitra",
    },
    {
      label: "Shambhavi (shambhavi@kgrp.in)",
      value: "shambhavi@kgrp.in",
      name: "Shambhavi",
    },
    {
      label: "Ritwik (ritwik@kgrp.in)",
      value: "ritwik@kgrp.in",
      name: "Ritwik",
    },
    { label: "Default", value: "Default", name: "Default" },
  ];

  // Define sender options with name and email
  const senderOptions = [
    {
      label: "Monica (monica@kgrp.in)",
      value: "monica@kgrp.in",
      name: "Monica",
    },
    { label: "Aman (aman07@kgrp.in)", value: "aman07@kgrp.in", name: "Aman" },
    {
      label: "Pavithra (pavithra@kgrp.in)",
      value: "pavithra@kgrp.in",
      name: "Pavithra",
    },
    {
      label: "Rakesh (rakesh@kgrp.in)",
      value: "rakesh@kgrp.in",
      name: "Rakesh",
    },
    {
      label: "Chaitra (chaitra@kgrp.in)",
      value: "chaitra@kgrp.in",
      name: "Chaitra",
    },
    {
      label: "Shambhavi (shambhavi@kgrp.in)",
      value: "shambhavi@kgrp.in",
      name: "Shambhavi",
    },
    {
      label: "Ritwik (ritwik@kgrp.in)",
      value: "ritwik@kgrp.in",
      name: "Ritwik",
    },
    { label: "Default", value: "Default", name: "Default" },
  ];

  // removed editedPincode state
  const [editedRows, setEditedRows] = useState(new Map()); // Track multiple edited rows

  const handleCellEditingStarted = () => {
    const saveBtn = document.getElementById("saveBtn");
    if (saveBtn) {
      saveBtn.style.display = "flex";
      saveBtn.style.padding = "16px 40px";
      saveBtn.style.fontSize = "16px";
      saveBtn.style.borderRadius = "4px";
    }
  };

  // ✅ Monitor editedRows to show/hide save button
  useEffect(() => {
    const saveBtn = document.getElementById("saveBtn");
    if (saveBtn) {
      if (editedRows.size > 0) {
        saveBtn.style.display = "flex";
        saveBtn.style.padding = "16px 40px";
        saveBtn.style.fontSize = "16px";
        saveBtn.style.borderRadius = "4px";
      } else {
        saveBtn.style.display = "none";
      }
    }
  }, [editedRows]);

  // ✅ Clear edited rows when checkbox selection changes
  const handleSelectionChanged = useCallback(() => {
    const gridApi = agGridRef.current?.api;
    if (!gridApi) return;

    const selectedNodes = gridApi.getSelectedNodes();
    const selectedRowIds = selectedNodes
      .filter((node) => node.data)
      .map((node) => node.data.email_bookingId || node.data._id);

    // Remove any edited rows that are no longer selected
    setEditedRows((prev) => {
      const newMap = new Map();
      prev.forEach((value, key) => {
        if (selectedRowIds.includes(key)) {
          newMap.set(key, value);
        }
      });
      return newMap;
    });
  }, []);

  const handleSaveClick = async () => {
    // ✅ Finalize any edits
    agGridRef.current?.api?.stopEditing();

    try {
      // ✅ Get all edited rows from the Map
      const editedRowsArray = Array.from(editedRows.values());

      if (editedRowsArray.length === 0) {
        // no rows to save
        return;
      }

      // ✅ Process all edited rows - send as array of objects
      const records = editedRowsArray
        .map((selectedRow) => {
          // ✅ Check that row has required data
          if (!selectedRow.email_hotel_name) {
            // missing required field
            return null;
          }

          // ✅ Construct payload only with available fields
          const record = {
            email_hotel_name: selectedRow.email_hotel_name,
          };

          if ("pincode" in selectedRow) {
            record.pincode = selectedRow.pincode ?? "";
          }

          if (selectedRow.email_hotel_city) {
            record.city = selectedRow.email_hotel_city;
          }

          // ✅ Add email_bookingId if available
          if (selectedRow.email_bookingId) {
            record.bookingId = selectedRow.email_bookingId;
          }

          // ✅ Add remarks directly as fields (only if they were edited)
          if ("remark1" in selectedRow) {
            record.remark1 = selectedRow.remark1 ?? "";
          }
          if ("remark2" in selectedRow) {
            record.remark2 = selectedRow.remark2 ?? "";
          }

          return record;
        })
        .filter((record) => record !== null); // Remove null records

      if (records.length === 0) {
        // no valid records
        return;
      }

      // ✅ Send as array of objects for multiple remarks
      const payload = { records };
      const response = await fetch(
        "https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/pincodeAddUpdate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      if (!response.ok) throw new Error("Failed to save data");

      // ✅ Show success message
      message.success(`Successfully saved ${records.length} row(s)`);

      // ✅ Clear edited rows after successful save
      setEditedRows(new Map());

      const saveBtn = document.getElementById("saveBtn");
      if (saveBtn) saveBtn.style.display = "none";

      // ✅ Refresh grid data to reflect changes
      refreshGridData();
    } catch (error) {
      message.error("Failed to save changes. Please try again.");
    }
  };

  // convertFileToBase64 moved to module scope

  // Simple AgGrid export function for visible rows
  const exportToExcel = () => {
    if (!agGridRef.current) {
      message.error("Grid not ready for export");
      return;
    }

    agGridRef.current.api.exportDataAsExcel({
      onlySelected: false,
      fileName: `Hotel_Email_Export_${moment().format("YYYY-MM-DD_HH-mm-ss")}.xlsx`,
      processCellCallback: (params) => {
        // Handle object values that would show as [object Object]
        if (params.value && typeof params.value === "object") {
          // For traveller_info - extract key details
          if (params.column.getColId() === "traveller_info") {
            const traveller = params.value;
            if (traveller.name || traveller.email || traveller.phone) {
              return `${traveller.name || ""} | ${traveller.email || ""} | ${traveller.phone || ""}`.trim();
            }
            return JSON.stringify(traveller);
          }

          // For email_logs - format as readable text
          if (params.column.getColId() === "email_logs") {
            if (Array.isArray(params.value)) {
              return params.value
                .map((log) =>
                  typeof log === "object"
                    ? `${log.status || ""} - ${log.timestamp || ""} - ${log.message || ""}`.trim()
                    : log,
                )
                .join("; ");
            }
            return JSON.stringify(params.value);
          }

          // For any other object, stringify it
          return JSON.stringify(params.value);
        }

        return params.value;
      },
    });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
      <PageHeader
        title="Email Followup"
        rightActions={
          <>
            {pendingUpdates.length > 0 && (
              <Button
                size="small"
                type="primary"
                onClick={handleUpdateClick}
                style={{ marginRight: 8 }}
              >
                Update
              </Button>
            )}

            <Button
              size="small"
              type="primary"
              onClick={() => navigate("/email_followup_config_list")}
              style={{ marginRight: 8 }}
            >
              View All Configurations
            </Button>

            <Button
              size="small"
              type="primary"
              onClick={() => navigate("/email_followup_config")}
              style={{ marginRight: 8 }}
            >
              Add Configuration
            </Button>
          </>
        }
      />

      <div style={{ display: "flex", alignItems: "flex-end" }}>
        {domain !== "myyatra" ? (
          <div style={{ padding: "8px 12px" }}>
            <Typography variant="xs" style={{ marginBottom: 4 }}>
              Select Segment
            </Typography>
            <Select
              value={segmentType}
              onChange={(type) => {
                setSegmentType(type);
                setSelectedClient(""); // ✅ Reset client when segment changes
              }}
              style={{ width: 200, marginLeft: "auto", marginBottom: 16 }}
              placeholder="Select Segment"
              allowClear
              size="small"
            >
              {[
                { key: "HOTEL", name: "Hotel" },
                { key: "AIRLINE", name: "Airline" },
                { key: "CLIENT", name: "Client" },
              ].map((item, key) => (
                <Option key={key} value={item.key}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </div>
        ) : null}
        {domain !== "myyatra" &&
        segmentType &&
        segmentType !== "Choose Segment" ? (
          <div style={{ padding: "8px 12px" }}>
            <Typography variant="xs" style={{ marginBottom: 4 }}>
              {segmentType === "HOTEL"
                ? "Select Hotel Client"
                : segmentType === "AIRLINE"
                  ? "Select Airline Client"
                  : segmentType === "CLIENT"
                    ? "Select Client"
                    : "Select Client"}
            </Typography>
            <Select
              value={selectedClient || undefined}
              onChange={handleChange}
              style={{ width: 200, marginLeft: "auto", marginBottom: 16 }}
              placeholder={
                segmentType === "HOTEL"
                  ? "Select Hotel Client"
                  : segmentType === "AIRLINE"
                    ? "Select Airline Client"
                    : segmentType === "CLIENT"
                      ? "Select Client"
                      : "Select Client"
              }
              allowClear
              size="small"
            >
              <Option value="" disabled>
                {segmentType === "HOTEL"
                  ? "Select Hotel Client"
                  : segmentType === "AIRLINE"
                    ? "Select Airline Client"
                    : segmentType === "CLIENT"
                      ? "Select Client"
                      : "Select Client"}
              </Option>
              {(clientNames || [])
                .filter(
                  (item) =>
                    !segmentType || item.type?.toUpperCase() === segmentType,
                )
                .map((item, key) => (
                  <Option key={key} value={item?.client_id}>
                    {item?.client_name}
                  </Option>
                ))}
            </Select>
          </div>
        ) : null}

        <div
          style={{
            marginLeft: "auto",
            padding: "8px 12px",
            display: "flex",
            gap: "15px",
          }}
        >
          <Button
            type="primary"
            style={{ margin: "12px 0" }}
            onClick={exportToExcel}
          >
            Export Table
          </Button>
          <Button
            type="primary"
            style={{ width: 220, margin: "12px 0" }}
            onClick={() => setIsBulkMailModalVisible(true)}
          >
            Bulk Mail
          </Button>

          <Button
            id="saveBtn"
            type="primary"
            className="savekBtnFollowup"
            style={{ display: "none" }}
            onClick={handleSaveClick}
          >
            Save {editedRows.size > 0 ? `(${editedRows.size} rows)` : ""}
          </Button>
        </div>
      </div>

      {/* Add the button to get selected rows */}

      {/* new ui---ishika */}

      <div className="logsContainer" style={{ display: "flex", gap: 16 }}>
        {loading || !eventData
          ? Array.from({ length: 6 }).map((_, index) => (
              <div
                key={index}
                style={{
                  flex: 1,
                  // flex: customStyle && customStyle.flex ? customStyle.flex : 1,
                  padding: 20,
                  borderRadius: 12,
                  background: "#f9f9f9",
                  minWidth: 150,

                  // boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Skeleton
                  active
                  title={false}
                  paragraph={{ rows: 2, width: ["40%", "60%"] }} // label & value placeholder
                />
              </div>
            ))
          : summaryCards.map((item, index) => (
              <StatusCard
                key={index}
                label={item.label}
                value={item.value}
                icon={item.icon}
                type={item.type}
                isSelected={selectedStatusLabel === item.label}
                onClick={() => {
                  setSelectedStatusLabel(item.label);
                  handleEmailFilter(item.label);
                }}
                customStyle={item.customStyle}
                gst={item.gst}
              />
            ))}
      </div>
      <div style={{ display: "flex", flex: 1 }}>
        <div
          className="ag-theme-alpine"
          style={{ height: "100%", width: "97%" }}
        >
          <AgTableServer
            ref={agGridRef}
            rowSelection="multiple"
            singleClickEdit={true}
            enableDirectEdit
            key={segmentType}
            onFirstDataRendered={handleFirstDataRendered}
            onCellEditingStarted={handleCellEditingStarted}
            onSelectionChanged={handleSelectionChanged}
            //onCellValueChanged={handleCellValueChanged}
            columnDefs={columnDefs}
            onCellValueChange={handleCellValueChange}
            endpoint={
              "https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/booking"
              // "http://localhost:7003/api/hotelFollowUp/booking"
            }
            // serverPayload={{
            //   database: "unified-hotel-followup",
            //   table: "booking-data",
            //   selectedClient: selectedClient,
            // }}
            groupSelectsChildren={true}
            autoGroupColumnDef={{
              headerName: "Group",
              cellRenderer: "agGroupCellRenderer",
              checkboxSelection: (params) =>
                (params.node && params.node.field === "email_hotel_name") ||
                params.node.field === "airline_name",
              cellRendererParams: {
                innerRenderer: (params) => {
                  // The group value (e.g., 'EMAIL_REQUIRED', 'RUNNING', etc.)
                  const groupValue = params.node?.key || params.value;

                  // The count for this group (from the grouped row's data)
                  // For server-side row model, params.data may be undefined for group rows,
                  // but for your response, it should be available as params.data.count
                  const count = params.data?.count;

                  return (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span>{groupValue}</span>
                      {typeof count === "number" && (
                        <span style={{ marginLeft: 8 }}>({count})</span>
                      )}
                    </div>
                  );
                },
              },
            }}
            onGridReady={handleGridReady}
            serverPayload={serverPayload}
            defaultColDef={defaultColDef}
            pdfDataKey="invoice_link_new"
            pdfV2
            enablePDFViewer
          />
        </div>
        <Button
          type="default"
          shape="circle"
          icon={open ? <RightOutlined /> : <LeftOutlined />}
          onClick={toggleDrawer}
          style={{
            position: "absolute",
            top: "50%",
            right: open ? "30%" : 0,
            transform: "translateY(-50%)",
            zIndex: 10,
          }}
        />
        <Drawer
          // title="Recent Email Activity"
          placement="right"
          closable={true}
          onClose={toggleDrawer}
          open={open}
          //width={650}
          bodyStyle={{ padding: 16 }}
        >
          <EmailActivityList
            applyFilterToTable={handleBookingIdFilter}
            applyTrackingFilter={handleBookingIdFilterBulk}
          />
        </Drawer>

        {/* <div
          style={{
            background: '#ffffff',
            boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
            borderRadius: '12px',
            padding: '16px',
            marginLeft: '16px',
            marginRight: '16px',
            //marginBottom: '16px',
            flex: 1,
          }}
        >
          <EmailActivityList
            applyFilterToTable={handleBookingIdFilter}
            applyTrackingFilter={handleBookingIdFilterBulk}
          />
        </div> */}
      </div>

      <Modal
        title="Send Bulk Mail"
        open={isBulkMailModalVisible}
        onOk={async () => {
          // Find sender info
          const sender = senderOptions.find(
            (opt) => opt.value === selectedEmail,
          ) || { name: "", email: selectedEmail };

          // Get selected rows from the grid
          const gridApi = agGridRef.current.columnApi.api;
          const selectedRows = gridApi.getSelectedRows();
          // Only include leaf/data rows (with _id or email_bookingId)
          const dataRows = selectedRows.filter(
            (row) => row._id || row.email_bookingId,
          );
          if (dataRows.length === 0) {
            message.warning(
              "Please select at least one row to send bulk mail.",
            );
            return;
          }

          let payload;
          if (sender.value === "Default") {
            // Only send the selected rows and cc (no customText or customFrom)
            payload = {
              customText: customMessage,
              selectedRows: dataRows,
              cc: ccEmails,
            };
          } else {
            // For all other senders, send the full payload as before
            payload = {
              customText: customMessage,
              customFrom: {
                name: sender.name,
                email: sender.value,
              },
              selectedRows: dataRows,
              cc: ccEmails,
            };
          }
          if (Array.isArray(nocFile) && nocFile.length > 0) {
            const base64Files = await Promise.all(
              nocFile.map(async (file) => {
                const base64 = await convertFileToBase64(file);
                return base64; // do not wrap again!
              }),
            );
            payload.nocAttachments = base64Files;
          }

          try {
            const response = await fetch(
              "https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/manualMailTrigger",
              {
                // const response = await fetch(" http://localhost:7003/api/hotelFollowUp/manualMailTrigger", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
              },
            );
            const result = await response.json();
            if (response.ok) {
              message.success(result.message || "Mail sent successfully");
            } else {
              message.error(result.message || "Failed to send mail");
            }
          } catch (error) {
            message.error("Failed to send mail");
          }
          setIsBulkMailModalVisible(false);
          setShowTextarea(false);
          setCustomMessage("");
          setCcEmails([]);
        }}
        onCancel={() => {
          setIsBulkMailModalVisible(false);
          setCcEmails([]);
        }}
        okText="Send"
        cancelText="Cancel"
      >
        {/* Custom "From" dropdown */}
        <div style={{ marginTop: 8 }}>
          <label>
            <b>From:</b>
          </label>
          <Select
            style={{ width: "100%", marginTop: 8 }}
            placeholder="Choose sender email"
            options={emailOptions}
            value={selectedEmail}
            onChange={(value) => setSelectedEmail(value)}
          />
        </div>

        {/* CC multi-select dropdown */}
        <div style={{ marginTop: 16 }}>
          <label>
            <b>CC:</b>
          </label>
          <Select
            mode="multiple"
            allowClear
            style={{ width: "100%", marginTop: 8 }}
            placeholder="Select CC emails"
            options={emailOptions}
            value={ccEmails}
            onChange={setCcEmails}
            optionRender={(option) => (
              <span style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="checkbox"
                  checked={ccEmails.includes(option.value)}
                  readOnly
                  style={{ marginRight: 8 }}
                />
                {option.label}
              </span>
            )}
          />
        </div>

        {/* Add custom message */}
        <div style={{ marginTop: 16 }}>
          {!showTextarea && (
            <Button
              type="link"
              icon={<PlusOutlined />}
              onClick={() => setShowTextarea(true)}
              style={{ color: "#0a8394", paddingLeft: 0 }}
            >
              Add Custom Message
            </Button>
          )}
        </div>

        {showTextarea && (
          <div style={{ marginTop: 8 }}>
            <label>
              <b>Custom Message:</b>
            </label>
            <TextArea
              rows={4}
              placeholder="Write your custom message here..."
              value={customMessage}
              onChange={(e) => setCustomMessage(e.target.value)}
            />
          </div>
        )}
        <div style={{ marginTop: 16 }}>
          <label>
            <b>NOC Attachment:</b>
          </label>
          <input
            type="file"
            accept=".pdf,.jpg,.jpeg,.png"
            multiple
            onChange={(e) => {
              const files = Array.from(e.target.files);
              setNocFile(files);
            }}
          />
          {nocFile && nocFile.length > 0 && (
            <ul style={{ marginTop: 8 }}>
              {nocFile.map((file, index) => (
                <li key={index}>{file.name}</li>
              ))}
            </ul>
          )}
        </div>
      </Modal>

      {/* Single Mail Modal */}
      <Modal
        title="Send Single Mail"
        open={isResendModalVisible}
        onOk={async () => {
          // Find sender info
          const sender = senderOptions.find(
            (opt) => opt.value === selectedEmail,
          ) || { name: "", email: selectedEmail };

          let payload;
          if (sender.value === "Default") {
            // Only send the selected row as payload (plus cc)
            payload = {
              ...resendRowData,
              cc: ccEmailsSingle,
            };
          } else {
            // For all other senders, send the full row data, customText, customFrom, and cc
            payload = {
              ...resendRowData, // all row data
              customText: customMessage,
              customFrom: {
                name: sender.name,
                email: sender.value,
              },
              cc: ccEmailsSingle,
            };
          }

          try {
            const response = await fetch(
              "https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/manualSingleMailTrigger",
              {
                // const response = await fetch("http://localhost:7001/api/hotelFollowUp/manualSingleMailTrigger", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
              },
            );
            const result = await response.json();
            if (response.ok) {
              message.success("Mail triggered successfully");
            } else {
              message.error(result?.message || "Something went wrong");
            }
          } catch (error) {
            message.error("Failed to trigger mail");
          }
          setIsResendModalVisible(false);
          setShowTextarea(false);
          setCustomMessage("");
          setCcEmailsSingle([]);
        }}
        onCancel={() => {
          setIsResendModalVisible(false);
          setCcEmailsSingle([]);
        }}
        okText="Send"
        cancelText="Cancel"
      >
        {/* Multi-checkbox for senders */}
        <div style={{ marginTop: 8 }}>
          <label>
            <b>From:</b>
          </label>
          <Select
            style={{ width: "100%", marginTop: 8 }}
            placeholder="Choose sender email"
            options={senderOptions}
            value={selectedEmail}
            onChange={setSelectedEmail}
          />
        </div>

        {/* CC multi-select dropdown */}
        <div style={{ marginTop: 16 }}>
          <label>
            <b>CC:</b>
          </label>
          <Select
            mode="multiple"
            allowClear
            style={{ width: "100%", marginTop: 8 }}
            placeholder="Select CC emails"
            options={emailOptions}
            value={ccEmailsSingle}
            onChange={setCcEmailsSingle}
            optionRender={(option) => (
              <span style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="checkbox"
                  checked={ccEmailsSingle.includes(option.value)}
                  readOnly
                  style={{ marginRight: 8 }}
                />
                {option.label}
              </span>
            )}
          />
        </div>

        {/* Add custom message */}
        <div style={{ marginTop: 16 }}>
          {!showTextarea && (
            <Button
              type="link"
              icon={<PlusOutlined />}
              onClick={() => setShowTextarea(true)}
              style={{ color: "#0a8394", paddingLeft: 0 }}
            >
              Add Custom Message
            </Button>
          )}
        </div>

        {showTextarea && (
          <div style={{ marginTop: 8 }}>
            <label>
              <b>Custom Message:</b>
            </label>
            <TextArea
              rows={4}
              placeholder="Write your custom message here..."
              value={customMessage}
              onChange={(e) => setCustomMessage(e.target.value)}
            />
          </div>
        )}
      </Modal>

      <Modal
        title="Template Details"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={800} // This sets the width to 800px
        footer={false}
        style={{ width: 800 }} // This is redundant if width is already set
      >
        {/* {templateData && (
          <div
            style={{
              height: 500,
              width: "100%",
              marginTop: 24,
              overflowY: "auto",
            }}
            dangerouslySetInnerHTML={{
              __html: renderTemplate(templateData, modalData),
            }}
          />
        )} */}
        {modalData?.booking_client_id &&
          clientTemplateHtmlMapRef.current[modalData.booking_client_id] && (
            <div
              style={{
                height: 500,
                width: "100%",
                marginTop: 24,
                overflowY: "auto",
              }}
              // dangerouslySetInnerHTML={{
              //   __html: renderTemplate(
              //     clientTemplateHtmlMap[modalData.booking_client_id]
              //       .html_content,
              //     modalData
              //   ),
              // }}
              dangerouslySetInnerHTML={{
                __html: renderTemplate(
                  clientTemplateHtmlMapRef?.current[modalData.booking_client_id]
                    .html_content,
                  {
                    ...modalData,
                    topBookings: [modalData],
                  },
                ),
              }}
            />
          )}
      </Modal>

      {modalConfig.visible && (
        <Modal
          title={
            modalConfig.type === "email"
              ? "Update Hotel Contact Email"
              : "Update Hotel Contact Number"
          }
          open={modalConfig.visible}
          onCancel={() => setModalConfig({ visible: false })}
          footer={false}
        >
          <HotelDataUpdate
            contactDetails={contactDetails}
            onSuccess={() => setModalConfig({ visible: false })}
            type={modalConfig.type}
            segmentType={segmentType}
            onDataRefresh={refreshGridData}
            onRowDataUpdate={updateRowData}
          />
        </Modal>
      )}
    </div>
  );
};

export default HotelEmail;

// Named test exports to improve unit coverage on pure helpers
export const __test__ = {
  // format INR values with Crore/Lakh logic
  formatAmountIndian,
  // base64 converter used for NOC attachments
  convertFileToBase64,
};
